module.exports = __webpack_public_path__ + "static/media/historic.133aae30.svg";